import { MutableRefObject, useEffect } from 'react';

const CLICK_OUTSIDE_IGNORE_SELECTOR =
    '[data-click-outside-ignore="true"], .Toastify, .Toastify__toast, .Toastify__close-button';

export const useClickOutside = (ref: MutableRefObject<HTMLElement | null>, onClickOutside: () => void) => {
    useEffect(() => {
        const onPointerDown = (e: MouseEvent | TouchEvent) => {
            if (!ref.current) return;

            const target = e.target;
            if (target instanceof Element && target.closest(CLICK_OUTSIDE_IGNORE_SELECTOR)) {
                return;
            }

            if (!ref.current.contains(e.target as HTMLElement)) {
                onClickOutside();
            }
        };

        window.addEventListener('mousedown', onPointerDown);
        window.addEventListener('touchstart', onPointerDown);

        return () => {
            window.removeEventListener('mousedown', onPointerDown);
            window.removeEventListener('touchstart', onPointerDown);
        };
    }, [onClickOutside, ref]);
};
